export default "__VITE_ASSET__B9no1ppY__"